// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1RkkL","container":"styles_container__1QKwB","title":"styles_title__1o3U3","wrapper":"styles_wrapper__3NWDC","answer":"styles_answer__3581W"};